'use client'
import type { FC } from 'react'
import BlogDetailPageStd from 'storefront-modules/blog/components/BlogDetailPageStd'
import { useAppConfigContext } from '#/src/appConfig'
import { useCustomCart } from '#/src/custom/cart/useCustomCart'
import useProductRequest from '#/src/custom/products/useProductRequest'
import { DeliveryDTO, ProductLightDTO, StorefrontWidget, WidgetBlog } from 'ecosystem'
import { CustomProductListItem } from '#/src/custom/products/CustomProductListItem'

interface BlogDetailPageProps {
  deliveryOptions: DeliveryDTO[] | null
  widget: StorefrontWidget<WidgetBlog>
  relatedProducts: ProductLightDTO[]
}

const BlogDetailPage: FC<BlogDetailPageProps> = ({ widget, deliveryOptions, relatedProducts }) => {
  const appConfig = useAppConfigContext()
  const { handleAddToCart, cartItems } = useCustomCart()
  const { handleProductRequest } = useProductRequest()

  return (
    <BlogDetailPageStd
      config={{
        widget,
        deliveryOptions,
        relatedProducts,
        onFeaturedProductBuy: handleAddToCart,
        cartItems,
        onProductRequest: handleProductRequest,
        paths: {
          productsUrlPath: appConfig.paths.productsUrlPath
        },
        customComponents: {
          ProductListItem: CustomProductListItem
        }
      }}
    />
  )
}

export default BlogDetailPage
